"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const viewGlossary_service_1 = require("../services/viewGlossary.service");
require("rxjs");
require("../Models");
const i0 = require("@angular/core");
const i1 = require("../services/viewGlossary.service");
const i2 = require("@angular/common");
const i3 = require("../../common/components/dnaR-back-to-top/dnaR-back-to-top.component");
function ViewGlossaryComponent_div_17_tr_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r3.code);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r3.description);
} }
function ViewGlossaryComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "table", 13);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "tbody");
    i0.ɵɵtemplate(7, ViewGlossaryComponent_div_17_tr_7_Template, 5, 2, "tr", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", category_r1.heading, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", category_r1.glossaryDetailListDto);
} }
class ViewGlossaryComponent {
    constructor(viewGlossaryService) {
        this.viewGlossaryService = viewGlossaryService;
        this.glossary = [];
    }
    ngOnInit() {
        this.getGlossaryWithSACodes();
    }
    getGlossaryWithSACodes() {
        this.viewGlossaryService.getGlossaryWithSACodes().then((result) => {
            this.glossary = result;
        });
    }
}
exports.ViewGlossaryComponent = ViewGlossaryComponent;
ViewGlossaryComponent.ɵfac = function ViewGlossaryComponent_Factory(t) { return new (t || ViewGlossaryComponent)(i0.ɵɵdirectiveInject(i1.ViewGlossaryService)); };
ViewGlossaryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ViewGlossaryComponent, selectors: [["viewGlosaaryList"]], decls: 19, vars: 1, consts: [[1, "view-funding-rates"], ["ng-show", "vm.mode === 'view'", 1, "glossary-header"], [1, "vertical-tabs"], [1, "row", "row-no-gutters"], [1, "col-xs-3"], [1, "tabs"], [1, "tab-glossary"], [1, "ng-scope", "active"], [1, "col-xs-9"], [1, "view-funding-rates-pane"], [1, "w-100"], [1, "funding-h2"], [4, "ngFor", "ngForOf"], [1, "table", "table-top-border"], ["colspan", "2", 1, "header-row", "table-bottom-border"], [1, "glossary-code"], [1, "glossary-description"]], template: function ViewGlossaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h1", 1);
        i0.ɵɵtext(2, "Glossary");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "table", 5);
        i0.ɵɵelementStart(7, "tbody", 6);
        i0.ɵɵelementStart(8, "tr", 7);
        i0.ɵɵelementStart(9, "td", 6);
        i0.ɵɵtext(10, "Funding");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelementStart(13, "div", 10);
        i0.ɵɵelementStart(14, "h2", 11);
        i0.ɵɵtext(15, "Funding");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div");
        i0.ɵɵtemplate(17, ViewGlossaryComponent_div_17_Template, 8, 2, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "dnaR-back-to-top");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngForOf", ctx.glossary);
    } }, directives: [i2.NgForOf, i3.DnaRBackToTop], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ViewGlossaryComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'viewGlosaaryList',
                templateUrl: './viewGlossary.component.html'
            }]
    }], function () { return [{ type: i1.ViewGlossaryService }]; }, null); })();
